export type IdType = 'category' | 'item' | 'recipe';
